export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8669.62e3e407.jpg";